import { useSelector } from "react-redux";
import { useGetBooksQuery } from "../redux/features/api/apiSlice";
import SingleItem from "./SingleItem";


export default function Grid() {
    const { data: books, isLoading, isError } = useGetBooksQuery();
    const {filter, search} = useSelector(state=>state.filters) || {};
  // filter callback functions
  const FilterCallback = (item)=> filter ? item.featured : true
  const searchCallback = (item)=> {
      if(search?.length > 0){
          return item.name.toLowerCase().includes(search.toLowerCase())
      } else {return true}
  }

    // decide what to render
    let content = null;

    if (isLoading) {
        content = <div>Loading...</div>
    }

    if (!isLoading && isError) {
        content = <div>There was an error</div>;
    }

    if (!isLoading && !isError && books?.length === 0) {
        content = <div>No videos found!</div>
    }

    if (!isLoading && !isError && books?.length > 0) {
        content = books
            .filter(FilterCallback)
            .filter(searchCallback)
            .map((book) => <SingleItem key={book.id} book={book} />);
    }



    return (
        <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
            {content}
        </div>
    )
};